<template>
  <div class="tradesman-career">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-l">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal v-model="showModalStatus"
           :title="title"
           @on-ok="createInfo()"
           :loading="loading">
      <Form :model="dataInfo"
            action="javascript:void(0)">
        <FormItem label="图片"
                  prop="thumb">
          <upload-thumb v-model="dataInfo.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="300"
                        :autoCropHeight="300"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:300*300'"></upload-thumb>
        </FormItem>
      </Form>
    </Modal>
    <!-- 图片查看 start -->
    <viewer :options="viewerOptions"
            :images="viewerImages"
            @inited="inited"
            class="viewerImageWraper"
            ref="viewerImageWraper">
      <template slot-scope="scope">
        <figure class="images">
          <div class="image-wrapper"
               v-for="img in viewerImages"
               :key="img">
            <img class="image"
                 :src="img"
                 :data-source="img"
                 :alt="img"
                 style="display: none;" />
          </div>
        </figure>
      </template>
    </viewer>
    <!-- 图片查看 end -->
  </div>
</template>
      
      <script>
import UploadThumb from "../common/thumb";

export default {
  name: "tradesman-career",
  data () {
    return {
      viewerOptions: {
        toolbar: true,
        url: "data-source"
      },
      viewerImages: [],
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      loading: true,
      dataloading: true,
      thumblist: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: '',
      formItem: {
        'key': '',
        uuid: '',
      },
      bigDisplay: '',
      list: [
        {
          title: 'Id',
          key: 'id',
          width: "100px"
        },
        {
          title: "图片",
          key: "thumb",
          width: 300,
          render: (h, params) => {
            return h("div", [
              h(
                "Avatar",
                {
                  props: {
                    src: this.$publicData.ossUrl + params.row.thumb,
                    shape: "square",
                    size: "large",
                    click: ""
                  },
                  nativeOn: {
                    click: () => {
                      this.visible = true;
                      this.imgUrl = this.$publicData.ossUrl + params.row.thumb;
                      this.viewerImages = [this.$publicData.ossUrl + params.row.thumb];
                      this.$viewer.show();
                    }
                  }
                },
                ""
              )
            ]);
          }
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.detail(params.index, params.row.id)
                  }
                }
              }, '编辑'),
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.remove(params.index, params.row.id)
                  }
                }
              }, '删除')
            ]);
          }
        }
      ],
      trandList: [],
      tablelist: [],
      dataInfo: {
        thumb: '',
      },
      showModalStatus: false,
    }
  },
  created: function () {
    // 取数据
    this.getTableList();
  },
  components: {
    UploadThumb
  },
  methods: {
    inited (viewer) {
      this.$viewer = viewer;
    },
    getTableList: function () {
      this.$api.defaultshopthumb.list({ "page": this.pages.page, "size": this.pages.size }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.count;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 展开添加
    showModel () {
      this.title = "添加";
      this.dataInfo = {
        title: '',
      };
      this.thumblist = new Array();
      this.showModalStatus = !this.showModalStatus;
    },
    // 添加
    createInfo (name) {
      if (this.$refs["uploadthumb"].uploadList.length > 0) {
        this.dataInfo.thumb = this.$refs["uploadthumb"].uploadList[0].url;
      } else {
        this.dataInfo.thumb = null;
      }
      if (this.dataInfo.id == null || this.dataInfo.id == 0) {
        this.$api.defaultshopthumb.create(this.dataInfo).then(res => {
          if (res.code == 200) {
            this.getTableList();
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
          this.showModalStatus = !this.showModalStatus;
        });
      } else {
        this.$api.defaultshopthumb.edit(this.dataInfo).then(res => {
          if (res.code == 200) {
            this.getTableList();
            this.showModalStatus = !this.showModalStatus;
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });

        });
      }
    },
    // 删除
    remove: function (index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: '警告',
        content: '<p>此操作不可恢复，三思而后行...</p>',
        onOk: () => {
          this.$api.defaultshopthumb.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    },
    // 详情
    detail (index, id) {
      this.title = "编辑";
      this.dataInfo = {
        title: '',
      };
      this.thumblist = new Array();
      this.showModalStatus = !this.showModalStatus;
      this.$api.defaultshopthumb.detail({ id: id }).then(res => {
        this.dataInfo = res.result;
        //处理thumb
        if (this.dataInfo.thumb != null && this.dataInfo.thumb != "") {
          this.thumblist.push({
            name: this.dataInfo.thumb,
            url: this.dataInfo.thumb,
            status: "finished"
          });
        }
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = { 'key': this.formItem.key, "page": this.pages.page, "size": this.pages.size, uuid: this.formItem.uuid };
      this.$api.defaultshopthumb.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
  },
}
      </script>
      